export enum ImageSize {
	HIGH = '1024x1792',
	LARGE = '1024x1024',
	MEDIUM = '512x512',
	SMALL = '256x256',
	WIDE = '1792x1024',
}
